import {Component, Inject} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { URLSearchParams } from '@angular/http';

import { oAuth } from '../providers/oAuth';


import { DatePipe } from '@angular/common';

@Component({
    selector: 'TemplateUploader',
    templateUrl: './TemplateUploader.component.html',
    styleUrls: ['./TemplateUploader.component.css']
})
export class TemplateUploader {

    file: File;
    reports: string[];

    PCdisplayedColumns = ['colPC', 'colDelete'];

    constructor(private http: HttpClient,
        public dialogRef: MatDialogRef<TemplateUploader>,
        @Inject(MAT_DIALOG_DATA) public data: any ) { }

    onNoClick(): void {
        this.dialogRef.close();
    }
    ngOnInit() {
        this.reports = [];
        this.forEachKey();

    }

    setClickedRow() {
        this.dialogRef.close();
    }

    TemplateAdd(event: EventTarget) {
        let eventObj: MSInputMethodContext = <MSInputMethodContext>event;
        let target: HTMLInputElement = <HTMLInputElement>eventObj.target;
        let files: FileList = target.files;
        this.file = files[0];
        this.getBase64(this.file);
    }

    getBase64(file: File) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
        localStorage.setItem(file.name, JSON.stringify(reader.result))
    };
    reader.onerror = function (error) {
        console.log('Error: ', error);
    };

    this.dialogRef.close();
    }

    forEachKey() {
        this.reports = [];

        for (var i = 0; i < localStorage.length; i++) {

            if (localStorage.key(i).includes(".repx")){
                this.reports.push(localStorage.key(i).toString());
            }
        }
    }

    DeleteTemplate(row) {
        localStorage.removeItem(row);
        this.dialogRef.close();
    }

    SelectTemplateRow(row: string) {
        var report = localStorage.getItem(row);
    }

}



// WEBPACK FOOTER //
// ./src/app/common/TemplateUploader.component.ts